// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1yCM7","label":"Category_label__2LKgE","content":"Category_content__3vS0o","header":"Category_header__1JKCv","location":"Category_location__2RD53"};